import { getState } from "./Constant/LocalStorage";
import { Base_Url, Hiver_Base_Url, apiRoutes } from "./Constant/ApiRoutes";

export const showMessage = (message) => {
  if (message) {
  }
};

export const logout = async () => {
  try {
    const logoutUrl = new URL(apiRoutes.kbLogout, Base_Url).toString();
    const response = await fetch(logoutUrl, {
      method: "POST",
      credentials: "include",
    });
    if (!response.ok) {
      console.warn("Logout request failed", response.status);
    }
  } catch (error) {
    console.warn("Logout request failed", error);
  } finally {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("kb_logged_out", "true");
    window.location.href = "/login";
  }
};

export const processUrl = (url) => {
  const adminDetails = getState("adminDetails");
  if (adminDetails?.usergroupNameSlug) {
    url = `${adminDetails.usergroupNameSlug}/${url}`;
  }
  return url;
}

//Returns the value of app_env and tier(used to make bifrost call) for different envs
export const getEnv = () => {
  const reactAppEnv = process.env.REACT_APP_KB_ENV;
  const isBuddyEnv = process.env.REACT_APP_IS_BUDDY_ENV;
  if (reactAppEnv === "dev") {
    //buddy-cli env
    return {
      app_env: "dev",
      tier: "dev",
    };
  } else if (isBuddyEnv === "true") {
    //Buddy qa env
    return {
      //start index 10 because it starts like https://v2 + userxp-5 + .hiver.space so accomodating it
      app_env: Hiver_Base_Url.substring(10, Hiver_Base_Url.indexOf('.hiver.space')),
      tier: "sit",
    };
  } else {
    //production env
    return {
      app_env: "v2master",
      tier: "production",
    };
  }
}